<template>
    <div>
        <h2 class="title is-2">
            Hello {{ $meta.userName }}!
        </h2>

        <LeadProperty>
            Answer these questions to help us with your enquiry.
        </LeadProperty>

        <hr />

        <h2 class="title is-4">
            What areas are you interested in?
        </h2>

        <article
            v-if="! availableAreas.length"
            class="message is-link"
        >
            <div class="message-body">
                Loading areas...
            </div>
        </article>

        <form
            v-if="availableAreas.length"
            @submit.prevent="submit"
        >
            <FormNotification />

            <SavingNotification />

            <div
                v-if="availableAreas.length"
                class="block"
            >
                <b-checkbox
                    v-for="area in availableAreas"
                    :key="area.strItem"
                    v-model="selectedAreas"
                    size="is-medium"
                    type="is-success"
                    :native-value="area.strItem"
                >
                    {{ area.strItem }}
                </b-checkbox>
            </div>

            <b-button
                type="is-info"
                tag="button"
                :disabled="isSending || ! selectedAreas.length || isSuccess"
                native-type="submit"
            >
                Save
            </b-button>
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Form from '../../mixins/form.js';
import LeadProperty from '../../components/LeadProperty.vue';

export default {
    components: {
        LeadProperty,
    },

    mixins: [
        Form,
    ],

    data: function() {
        return {
            selectedAreas: [],
        };
    },

    computed: {
        ...mapState('leadQuestions', [
            'availableAreas',
            'savedAreas',
        ])
    },

    mounted() {
        this.getSavedAreas();
    },

    methods: {
        getSavedAreas() {
            this.$store.dispatch('leadQuestions/getSavedAreas')
                .then(() => {
                    /*
                    if(this.savedAreas.length) {
                        // skip this step if question has already been answered
                        this.$router.push({
                            name: 'lead-questions',
                        });
                    }
                    */

                    this.getAvailableAreas();
                });
        },
        getAvailableAreas() {
            this.$store.dispatch('leadQuestions/getAvailableAreas')
            .then(() => {
                if(! this.availableAreas.length) {
                    // skip this step if no areas are returned
                    this.$router.push({
                        name: 'lead-questions',
                    });
                }
            })
            .catch(() => {
                // skip this step if no areas are returned
                this.$router.push({
                    name: 'lead-questions',
                });
            });
        },
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return this.parseClientErrors();
                }

                this.isSending = true;

                this.$store.dispatch('leadQuestions/saveSelectedAreas', this.selectedAreas)
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;

                    // on success, redirect to 'lead-questions'
                    if(response.data.outcome === 'success') {
                        this.$router.push({
                            name: 'lead-questions',
                        });
                    }
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
